import { render, staticRenderFns } from "./DefaultProductCreate.vue?vue&type=template&id=705fe05a"
import script from "./DefaultProductCreate.vue?vue&type=script&lang=js"
export * from "./DefaultProductCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports